<div *ngIf="!isUserLoggedIn && tenantService.tenantIdentifier!= null" class="login-container">
  <div class="container vertical-center">
    <div class="auth-column">
        <div id="logo" class="nice-esp-logo" role="img" [attr.aria-label]="'login.logo' | translate">
        </div>
        <div class="auth-card">
            <h1 id="signin-heading" class="sign-in-text card-title">{{"login.signin" | translate}}</h1>
            <form [formGroup]="loginForm" novalidate (submit)="logUserIn()" aria-labelledby="signin-heading">
              <div class="form-group">
                <label for="username" class="input-label">{{'login.username' | translate}}<span
                    class="required-asterisk" aria-hidden="true"> *</span></label>
                <div class="input-group wfm-input-group input-group-username">
                  <input #usernameInput [(ngModel)]="txtUsername" (ngModelChange)="txtUsernameChanged($event)" type="text" class="form-control wfm-form-control" formControlName="username" id="username"
                         autocomplete="off" minlength="1" maxlength="75"
                         [attr.disabled]="isLoadingFlag || isLoadingLanguage? '' : null" [ngClass]="showErrorUsername ? 'input-txt-error' : ''"
                         [attr.aria-invalid]="formControlIsInvalid('username')"
                         aria-describedby="errorUsername"
                         required aria-required="true"
                         autofocus>
                  <div id="errorUsername" class="invalid-feedback" wfm-error-message-username
                       role="alert">
                    <ng-container *ngIf="showErrorUsername && getFormControlErrors('username') !== null">
                      <ng-container *ngTemplateOutlet="errorMessages; context: {$implicit: getFormControlErrors('username')}">
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="password" class="input-label">{{'login.password' | translate}}<span
                    class="required-asterisk" aria-hidden="true"> *</span></label>
                <div class="input-group wfm-input-group input-group-password">
                  <input [(ngModel)]="txtPassword" (ngModelChange)="txtPasswordChanged($event)" [attr.type]="showPassword ? 'text': 'password'"
                         class="form-control wfm-form-control wfm-input-with-icon" formControlName="password"
                         id="password" autocomplete="off" #inputPassword minlength="1"
                         [attr.disabled]="isLoadingFlag || isLoadingLanguage? '' : null" [ngClass]="showErrorPassword ? 'input-txt-error' : ''"
                         [attr.aria-invalid]="formControlIsInvalid('password')"
                         aria-describedby="errorPassword"
                         required aria-required="true"
                         maxlength="256">
                  <div class="input-group-append wfm-input-password-icon">
                    <button type="button" class="input-group-text" wfm-input-password-icon (click)="togglePasswordIcon()"
                         [attr.aria-label]="(showPassword ? 'login.password.hide' : 'login.password.show') | translate"
                         [attr.aria-pressed]="showPassword"
                         [ngClass]="passwordCssValidationObject">
                      <esp-icon wfm-input-pwd-show name="eye" *ngIf="!showPassword"></esp-icon>
                      <esp-icon wfm-input-pwd-hide name="eye-off" *ngIf="showPassword"></esp-icon>
                    </button>
                  </div>
                  <div id="errorPassword" class="invalid-feedback" wfm-error-message-password
                       role="alert">
                    <ng-container *ngIf="showErrorPassword && getFormControlErrors('password') !== null">
                      <ng-container *ngTemplateOutlet="errorMessages; context: {$implicit: getFormControlErrors('password')}">
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div class="login-failed-message form-group" data-t="loginFailedMessage" role="alert">
                <ng-container *ngIf="showInvalidLoginMessage | async">{{loginErrorMessage}}</ng-container>
              </div>
              <div class="form-group language">
                <wfm-select #localeCombo selectName="localeCombo" selectId="localeCombo"
                  [label]="'login.language' | translate" [required]="false"
                  [items]="localeComboList" [attr.disabled]="!isLoadingFlag || isLoadingLanguage? null : ''"
                  (wfmSelectEvent)="updateLocaleCombo($event)" [selectedItem]="localeComboSelected">
                </wfm-select>
              </div>
              <button type="submit" id="btnLogin" class="auth-primary-button"
                      [attr.disabled]="isLoadingFlag || isLoadingLanguage ? true : null">
                  {{"login.signin" | translate}}
              </button>
            </form>
            <ng-template #errorMessages let-errors>
              <ng-container *ngIf="errors.required">{{"login.error.required" | translate}}<br/></ng-container>
              <ng-container *ngIf="errors.minlength">
                  {{"login.error.minlengthBefore" | translate}} {{errors.minlength.requiredLength}} {{"login.error.minlengthAfter" | translate}}<br/>
              </ng-container>
              <ng-container *ngIf="errors.maxlength">
                  {{"login.error.maxlengthBefore" | translate}} {{errors.maxlength.requiredLength}} {{"login.error.maxlengthAfter" | translate}}<br/>
              </ng-container>
              <ng-container *ngIf="errors.pattern">
                  {{"login.error.pattern" | translate}}
              </ng-container>
            </ng-template>
            <wfm-plan-loading-overlay *ngIf="isLoadingFlag || isLoadingLanguage"></wfm-plan-loading-overlay>
        </div>
    </div>
  </div>
  <footer *ngIf="!isUserLoggedIn" class="copyRight-contactUs" id="copyRight-contactUs">
    <span id="copyrightMessage">{{copyrightMessage}}</span>
  </footer>
</div>
<div class="login-loading-content" *ngIf="isUserLoggedIn">
  <div *ngIf="isLoadingFlag">
    <wfm-plan-loading-overlay></wfm-plan-loading-overlay>
    <div class="page-header">
      <wfm-page-title title="{{'login.page.loading' | translate}}"></wfm-page-title>
    </div>
    <p>{{'login.page.loading.details' | translate}}</p>
  </div>
  <div *ngIf="!isLoadingFlag">
    <div class="page-header">
      <wfm-page-title title="{{'login.page.loading.error' | translate}}"></wfm-page-title>
    </div>
    <p>{{'login.page.loading.error.details' | translate}}</p>
    <breeze-button buttonText="{{'login.page.loading.retry'|translate}}"
                        [isPrimary]="true"
                        (clicked)="authorizeUser()"></breeze-button>
</div>
</div>